export const sucursalesSlice = (set,get) => ({
    sucursales: [],
    handleSucursal: (e) => {
        console.log(e);
        set({ datos: { ...get().datos, sucursales: [e] } })
    },
    obtenerSucursales: async() => {
        await fetch("/p_sucursales")
        .then((res) => res.json())
        .then((data) => {
            if(data.status === 1){
                set({ sucursales: data.data.map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }) })
            }
        });
    }
})